import { useEventbriteUrl } from '@/common/constants/useEventbriteUrl';
import styles from '@/styles/Home.module.css';
import { Typography } from '@eventbrite/marmalade';
import Link from 'next/link';
import React from 'react';
import ContactOrganizerInstructions from '../ContactOrganizerInstructions/ContactOrganizerInstructions';
export interface ContactOrganizerInfoProps {
  infoText: string;
}

const ContactOrganizerInfo: React.FC<ContactOrganizerInfoProps> = ({ infoText }) => {
  const CONTACT_ORGANIZER_URL = useEventbriteUrl('CONTACT_ORGANIZER_URL');
  return (
    <div className="contact-organizer-info">
      <Typography>
        {infoText}{' '}
        <Link href={CONTACT_ORGANIZER_URL} target="_blank" passHref className={styles.url}>
          contact the event organizer
        </Link>
        , they can usually help.
      </Typography>
      <ContactOrganizerInstructions />
    </div>
  );
};

export default ContactOrganizerInfo;
